// Clear header (home page, collection pages with a banner photo, product pages
// on phones): the announcement bar and header are see-through at the very top
// and solid once the visitor scrolls (see assets/component-clear-header.css).
( function () {

	const root = document.documentElement;
	const THRESHOLD = 2;

	// Toggling one class is cheap and changes nothing when the value is the
	// same, so no throttling is needed.
	function update() {
		root.classList.toggle('home-header-solid', ( window.scrollY || window.pageYOffset ) > THRESHOLD);
	}

	update();
	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('pageshow', update);

	// The bars no longer take up room, so the header has to be pushed down by
	// the announcement bar's height (it wraps onto two lines on narrow screens),
	// and a few things (e.g. the product photo's swipe hint) need to know where
	// the header ends. Hand the live heights to the stylesheets as
	// --clear-ann-h and --clear-header-h.
	const bar = document.querySelector('announcement-bar');
	const header = document.getElementById('site-header');
	function setHeights() {
		// getBoundingClientRect, not offsetHeight: offsetHeight rounds to a whole pixel,
		// which leaves a hairline gap (or overlap) between the two bars whenever
		// the bar's real height is fractional (e.g. 49.6px on very narrow phones).
		root.style.setProperty('--clear-ann-h', ( bar ? bar.getBoundingClientRect().height : 0 ) + 'px');
		if ( header ) root.style.setProperty('--clear-header-h', header.getBoundingClientRect().height + 'px');
	}
	setHeights();
	if ( 'ResizeObserver' in window ) {
		const ro = new ResizeObserver(setHeights);
		if ( bar ) ro.observe(bar);
		if ( header ) ro.observe(header);
	} else {
		window.addEventListener('resize', setHeights);
	}

} )();
